import { FC } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';

type Props = any;

export const PreviewItem: FC<Props> = ({ ...props }) => {
  return (
    <a className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' {...props}>
      <KTSVG path='/media/icons/duotune/ecommerce/ecm009.svg' className='svg-icon-3' />
    </a>
  );
};
